import React from 'react';
import { Button } from '@mui/material';
import styled from '@emotion/styled';

import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';
import KeyboardDoubleArrowLeftRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftRounded';

import useIsMobile from '../../../hooks/useIsMobile';

const PageButton = styled(Button)`
  min-width: auto;
  padding: .2rem .8rem;
`;

const ArrowButton = styled(Button)`
  min-width: auto;
  padding: .2rem .3rem;
`;

const PaginationBar = ({ 
  currentPage = 1,
  totalPages = 1,
  onPageChange = () => {} 
}) => {
  const isMobile = useIsMobile();

  const getPageNumbers = () => {
    // Mobile view - show only 2 previous numbers
    if (isMobile) {
      if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }
      
      if (currentPage <= 2) {
        return [1, 2, 3, '...', totalPages];
      }
      
      if (currentPage >= totalPages - 2) {
        return [1, '...', totalPages - 2, totalPages - 1, totalPages];
      }
      
      return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
    }
    
    // Desktop view - original logic
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, '...', totalPages - 1, totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [1, 2, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, 2, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages - 1, totalPages];
  };

  return (
    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <ArrowButton
        color="basic"
        variant="outlined"
        size="small"
        onClick={() => onPageChange(0)}
        disabled={currentPage === 0}
      >
        <KeyboardDoubleArrowLeftRoundedIcon />
      </ArrowButton>
      
      <ArrowButton
        color="basic"
        variant="outlined"
        size="small"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
      >
        <KeyboardArrowLeftRoundedIcon />
      </ArrowButton>

      {getPageNumbers().map((page, index) => (
        <PageButton
          color="basic"
          key={index}
          variant={page === (currentPage + 1) ? "contained" : "outlined"}
          size="small"
          onClick={() => typeof page === 'number' ? onPageChange(page - 1) : null}
          disabled={page === '...'}
        >
          {page}
        </PageButton>
      ))}

      <ArrowButton
        color="basic"
        variant="outlined"
        size="small"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <KeyboardArrowRightRoundedIcon />
      </ArrowButton>

      <ArrowButton
        color="basic"
        variant="outlined"
        size="small"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <KeyboardDoubleArrowRightRoundedIcon />
      </ArrowButton>
    </div>
  );
};

export default PaginationBar;